// extracted by mini-css-extract-plugin
export default {"hamburger":"hamburger_hamburger__8PI-v","icon":"hamburger_icon__PdWp5","iconClose":"hamburger_iconClose__Yv31r","hamburgerLarge":"hamburger_hamburgerLarge__fV7jp"};